import React, { forwardRef, useState } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './Checkbox.module.css'

import CheckIcon from './check.svg'
import DashIcon from './dash.svg'

export const Checkbox = forwardRef((props, ref) => {
  const [internalChecked, setInternalChecked] = useState(props.checked ?? false)

  const { className, label = '', children, isIndeterminate, ...rest } = props

  const isChecked = typeof props.checked === 'undefined' ? internalChecked : props.checked
  const isIndeterminateState = isIndeterminate && !isChecked
  const isActive = isChecked || isIndeterminateState

  const handleChange = (e) => {
    if (typeof props.checked !== 'undefined' && props.onChange) {
      props.onChange(e)
      return
    }

    setInternalChecked(!isChecked)
  }

  return (
    <label className={cx(styles.Control, className)} {...(rest.id ? { htmlFor: props.id } : {})}>
      <input className={styles.DefaultCheckbox} {...rest} onChange={handleChange} ref={ref} type='checkbox' />
      <span
        id={`${props.id}-checkbox-tick`}
        data-checkbox-state={isActive ? 'active' : ''}
        className={cx(styles.Checkbox, { [styles.Active]: isActive })}
      >
        {isChecked && <CheckIcon className={styles.Icon} />}
        {isIndeterminateState && <DashIcon className={styles.Icon} />}
      </span>
      <span className={styles.Label}>{label || children}</span>
    </label>
  )
})

Checkbox.displayName = 'Checkbox'

Checkbox.propTypes = {
  /** State of the checkbox. checked or not */
  checked: PropTypes.bool,
  /** Indeterminate state of the checkbox */
  isIndeterminate: PropTypes.bool,
  /** Label for the component */
  label: PropTypes.string
}

export default Checkbox
